import { render, staticRenderFns } from "./MakeOrder.vue?vue&type=template&id=53cbfc1c&scoped=true"
import script from "./MakeOrder.vue?vue&type=script&lang=js"
export * from "./MakeOrder.vue?vue&type=script&lang=js"
import style0 from "./MakeOrder.vue?vue&type=style&index=0&id=53cbfc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cbfc1c",
  null
  
)

export default component.exports